/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const appConfig = sqliteTable('app_config', {
  id: text('id').primaryKey().notNull(),
  org_name: text('org_name'),
  org_localname: text('org_localname'),
  logo_url: text('logo_url'),
  country: text('country'),
  region: text('region'),
  language: text('language'),
  currency: text('currency'),
  org_address: text('org_address'),
  org_phone: text('org_phone'),
  org_mobile: text('org_mobile'),
  org_email: text('org_email'),
  sms_sender_name: text('sms_sender_name'),
  extra_json: text('extra_json'),
  updated_at: text('updated_at'),
  updated_by: text('updated_by'),
});
